import type { DisclaimerPolicyOption } from '../types/customDisclaimers';

export const filterDisclaimerPolicyOptions = (
  policyOptions: ReadonlyArray<DisclaimerPolicyOption>,
  selectedPolicyIds: ReadonlyArray<string>,
  searchQuery: string,
): DisclaimerPolicyOption[] => {
  const normalizedQuery = searchQuery.trim().toLocaleLowerCase();

  return policyOptions.filter((option) =>
    option.name.toLocaleLowerCase().includes(normalizedQuery)
      && !selectedPolicyIds.includes(option.id),
  );
};

export const getNextEnabledPolicyOptionIndex = (
  policyOptions: ReadonlyArray<DisclaimerPolicyOption>,
  currentIndex: number,
  direction: 1 | -1,
): number => {
  if (policyOptions.length === 0) {
    return -1;
  }

  let startIndex = currentIndex;
  if (currentIndex === -1) {
    startIndex = direction === 1 ? -1 : 0;
  }

  for (let offset = 1; offset <= policyOptions.length; offset += 1) {
    const nextIndex = (startIndex + (direction * offset) + policyOptions.length) % policyOptions.length;
    if (!policyOptions[nextIndex].disabled) {
      return nextIndex;
    }
  }

  return -1;
};